export default __webpack_public_path__ + "static/media/asiacup-evan.9605cc99.png";